<template>
    <div class="mainDiv">
        <div class="card">
            <div class="titulo-card" :id="listAb.id">
                <div class="card-header">
                    {{ listAb.tipoChamado.descricao }} - {{ formatarData(listAb.data) }} , {{ listAb.hora }}
                    <!-- - {{ tpChamadoListSub.descricao }} -->
                </div>
            </div>
            <ul>
                <li>
                    <button class="botao" id="finalizar-btn" data-bs-toggle="modal" @click="FinalizarAtendimento">
                        <svg xmlns="http://www.w3.org/2000/svg" height="24" width="24" id="ico-concluido">
                            <path
                                d="M10.575 17.15 18.2 9.525l-1.95-1.95-5.675 5.675-2.825-2.825-1.925 1.95ZM12 22.875q-2.25 0-4.237-.85-1.988-.85-3.463-2.325t-2.325-3.462q-.85-1.988-.85-4.238 0-2.275.85-4.263.85-1.987 2.325-3.462t3.463-2.313Q9.75 1.125 12 1.125q2.275 0 4.262.837 1.988.838 3.463 2.313t2.313 3.462q.837 1.988.837 4.263t-.837 4.25q-.838 1.975-2.313 3.45t-3.463 2.325q-1.987.85-4.262.85Z" />
                        </svg>Finalizar
                    </button>
                </li>
                <li>
                    <button class="botao" id="cancelar-btn" data-bs-toggle="modal" @click="CancelarAtendimento">
                        <svg xmlns="http://www.w3.org/2000/svg" height="24" width="24" id="ico-cancelar">
                            <path
                                d="M8.425 17.425 12 13.85l3.575 3.575 1.85-1.85L13.85 12l3.575-3.575-1.85-1.85L12 10.15 8.425 6.575l-1.85 1.85L10.15 12l-3.575 3.575ZM12 22.875q-2.25 0-4.237-.85-1.988-.85-3.463-2.325t-2.325-3.462q-.85-1.988-.85-4.238 0-2.275.85-4.263.85-1.987 2.325-3.462t3.463-2.313Q9.75 1.125 12 1.125q2.275 0 4.262.837 1.988.838 3.463 2.313t2.313 3.462q.837 1.988.837 4.263t-.837 4.25q-.838 1.975-2.313 3.45t-3.463 2.325q-1.987.85-4.262.85Z" />
                        </svg>Cancelar
                    </button>
                </li>
            </ul>
        </div>
    </div>
    <ModalConfirmaAgape v-if="state.modalConfirmaVisivel" :visible="state.modalConfirmaVisivel"
        :title="'Compartilhe sua avaliação conosco'" :usarConfirmar="true" :usarNegar="true" :captionConfirm="'Confirmar'"
        :captionCancelar="'Cancelar'"
        @modalResult="ModalConfirmaResult">
        <template v-slot:motivo>
            <div class="d-flex justify-content-center">
                <star-rating v-model:rating="state.valorAvaliacao">
                </star-rating>
                <!-- <input type="text" placeholder="Dê sua opinião"> -->
            </div>
            <textarea cols="30" rows="2" placeholder="Dê sua opinião (Opcional)" class="mt-2 teste"
                v-model="state.opiniaoAvaliacao"></textarea>
        </template>
    </ModalConfirmaAgape>
</template>

<script setup>
import api from '@/api/api';
import moment from 'moment';
import ModalConfirmaAgape from './ModalConfirmaAgape.vue';
import StarRating from 'vue-star-rating';
import { onMounted, reactive, defineProps, defineEmits, computed } from 'vue';
import roteador from '@/roteador/indexRoteador';
import store from '@/store/store';

moment.updateLocale('pt-br', {
    months: [
        "de Janeiro", "de Fevereiro", "de Março", "de Abril", "de Maio", "de Junho",
        "de Julho", "de Agosto", "de Setembro", "de Outrubro", "de Novembro", "de Dezembro"
    ]
});

const props = defineProps(['listAb', 'tpChamadoListSub',]);

const emits = defineEmits(['cancelar', 'excluir'])

const state = reactive({
    modalConfirmaVisivel: false,
    valorAvaliacao: 0,
    opiniaoAvaliacao: String()
});

async function FinalizarAtendimento() {
    state.valorAvaliacao = config.value.estrelaPadrao;
    state.modalConfirmaVisivel = true;
}

async function CancelarAtendimento() {
    await api.cancelarAtendimento(props.listAb.id)
        .then(resposta => {
            if (resposta.toUpperCase() == "OK") {
                emits('cancelar', props.listAb.id);
            }
        })
        .catch(erro => {
            alert(`Parece que há um problema de conexão ${erro}`)
        });
}

function formatarData(pData) {
    return moment(pData).format("DD MMMM");
}

async function ModalConfirmaResult(resp) {

    if (resp.toUpperCase() == "OK"){
    
    await api.ChamadoAvaliar(props.listAb.id, state.valorAvaliacao, state.opiniaoAvaliacao)
        .catch(erro => { console.log(erro) });

    await api.finalizarAtendimento(props.listAb.id)
        .then(resposta => {
            if (resposta.toUpperCase() == "OK") {
                emits('excluir', props.listAb.id);
            }
        })
        .catch(erro => {
            alert(`Parece que há um problema de conexão ${erro}`)
        });
    }
    state.modalConfirmaVisivel = false;
}

const config = computed(() => {
    return store.state.config;
});
</script>

<style scoped>
main {
    display: flex;
    flex-direction: column;

}

label {
    position: relative;
    bottom: 50px;
    left: 75px;
    font-weight: bolder;
    font-family: Tahoma;
}

ul {
    margin-top: 20px;
    margin-bottom: 0;
}

li {
    margin-bottom: 32px;
}

.circulo {
    width: 75px;
    height: 75px;
    border-radius: 50%;
    overflow: hidden;
    float: center;
    cursor: pointer;
}

.forest {
    background-color: forestgreen;
}

.card-header {
    border-bottom: none;
    padding-top: 25px;
    background-color: rgba(255, 255, 255, 0);
}

.teste {
    min-width: 100%;
}
</style>